import React, { useEffect, useRef, useState } from "react";
import Footer from "Components/Footer/Footer";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CVContainer from "Components/CV/CVContainer/CVContainer";
import CVPaniers from "Components/CV/CVPaniers/CVPaniers";
import CVSauvegardes from "Components/CV/CVSauvegardes/CVSauvegardes";
import { Navigate } from "react-router-dom";
import ButtonsBarDisconnected from "Components/Header/ButtonsBarDisconnected/ButtonsBarDisconnected";
import { useFetchGetConditional } from "Services/api";
import Header from "Components/Header/Header";
import NavBarTab from "Components/NavBar/NavBarTab/NavBarTab";
import { updateSecondaryTables } from "Redux/Actions/secondaryTablesActions";

const CVTheque = (props) => {
  // eslint-disable-next-line no-unused-vars
  const [activeIndex, setActiveIndex] = useState(0);
  const cvTheque = useRef(0);

  //Import des données user pour les avoir au rechargement de la page
  const domaines = useFetchGetConditional(
    "/domains",
    props.auth.token,
    props.secondaryTables.domainsData
  );
  const composantes = useFetchGetConditional(
    "/education_composantes",
    props.auth.token,
    props.secondaryTables.educationComposanteData
  );
  const levelOfEducation = useFetchGetConditional(
    "/level_of_educations",
    props.auth.token,
    props.secondaryTables.levelOfEducationsData
  );
  const levelOfExperience = useFetchGetConditional(
    "/level_of_experiences",
    props.auth.token,
    props.secondaryTables.levelOfExperiencesData
  );

  useEffect(() => {
    composantes.loaded &&
      domaines.loaded &&
      levelOfEducation.loaded &&
      levelOfExperience.loaded &&
      props.handleUpdateSecondaryTables({
        levelOfEducationsData: levelOfEducation.data,
        domainsData: domaines.data,
        levelOfExperiencesData: levelOfExperience.data,
        educationComposanteData: composantes.data,
      });
  }, [
    composantes.loaded,
    domaines.loaded,
    levelOfEducation.loaded,
    levelOfExperience.loaded,
  ]);

  function setActiveCVTheque(i) {
    cvTheque.current = i;
  }

  // Renvoie les différents composants en fonction de l'index actif
  function getComponentWithIndex() {
    switch (props.items.activeItemCVTheque) {
      case 0:
        return (
          <CVContainer
            activeIndex={props.items.itemsCVTheque.findIndex(
              (index) => index.label == "Cv thèque"
            )}
            setActiveIndex={setActiveIndex}
            items={props.items.itemsCVTheque}
            cvTheque={cvTheque.current}
          />
        );
      case 1:
        return (
          <CVSauvegardes
            activeIndex={props.items.itemsCVTheque.findIndex(
              (index) => index.label == "Cv sauvegardés"
            )}
            setActiveIndex={setActiveCVTheque}
            items={props.items.itemsCVTheque}
          />
        );
      case 2:
        return (
          props.auth.isAdmin && (
            <CVPaniers
              activeIndex={props.items.itemsCVTheque.findIndex(
                (index) => index.label == "Paniers de cv"
              )}
              setActiveIndex={setActiveIndex}
              items={props.items.itemsCVTheque}
            />
          )
        );
    }
  }

  return (
    <div>
      <Header>
        {props.auth.isConnected ? (
          <NavBarTab
            select="cvtheque"
            activeIndex={activeIndex}
            items={props.items}
          />
        ) : (
          <ButtonsBarDisconnected />
        )}
      </Header>
      <div className="CVTheque">
        {props.auth.isConnected ? (
          getComponentWithIndex()
        ) : (
          <Navigate to={`/`} />
        )}
      </div>
      <Footer />
    </div>
  );
};

CVTheque.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.object,
  secondaryTables: PropTypes.object,
  handleUpdateSecondaryTables: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  secondaryTables: state.secondaryTables,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateSecondaryTables: (value) => {
    dispatch(updateSecondaryTables(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CVTheque);
